import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import { ResponseMetricsDTO } from "../types/Repsonse";


// Base URL for Mentoring Fusion API
const API_URL = process.env.REACT_APP_MENTORING_API_URL ?? "";

class ResponseService {
    private apiClient: AxiosInstance;

    constructor() {
        this.apiClient = new ApiClient(API_URL).getClient();
    }

    public getResponseMetrics = async (
        organizationId: string,
        campaignId: string
    ): Promise<ResponseMetricsDTO> => {
        const response = await this.apiClient.get<ResponseMetricsDTO>(
            `/organizations/${organizationId}/campaigns/${campaignId}/responses`
        );
        return response.data;
    };

}

const responseService = new ResponseService();
export default responseService;